<template>
  <div class="login-outer">
    <div class="login-inner">
      <h4>{{ $t("resetpwd.TITLE") }}</h4>
      <form @submit.prevent="handleSubmit">
        <label for="name">{{ $t("resetpwd.FIELD_EMAIL") }}</label>
        <div>
          <input
            class="loginField"
            id="email"
            type="email"
            v-model="formData.email"
            required
            autofocus
            autocomplete
            autoCorrect="off"
            autoCapitalize="none"
          />
        </div>
        <div>
          <p></p>
          <p class="button-line">
            <button type="submit">
              {{ $t("resetpwd.BUTTON_SEND") }}
            </button>
            &nbsp;
            <button @click="goback">
              {{ $t("resetpwd.BUTTON_DISMISS") }}
            </button>
          </p>
        </div>
        <div>
          <p v-if="errors.length">
            <b>{{ $t("resetpwd.CHANGE_ERRORS_TEXT") }}</b>
          </p>

          <ul class="errors">
            <li v-for="error in errors" :key="error">
              {{ error }}
            </li>
          </ul>
        </div>
        <div v-if="errorMsg">
          {{ errorMsg }}
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import apiClient from "../services/apiClient";
import config from "../config";

export default {
  data() {
    return {
      formData: {
        email: ""
      },
      errors: [],
      errorMsg: undefined,
      messages: {
        ERR_REMOTE_UNREACHABLE: this.$t("login.ERR_REMOTE_UNREACHABLE"),
        ERR_REMOTE_ERROR: this.$t("login.ERR_REMOTE_ERROR"),
        MSG_EMAIL_SENT: this.$t("resetpwd.MSG_EMAIL_SENT")
      },
      serverMessages: {
        "Network Error": this.$t("login.ERR_LOCAL_UNREACHABLE"),
        "new password does not meet password policy rules": this.$t(
          "resetpwd.ERR_SERVER_PWD_POLICY_RULES"
        ),
        "old password do not match": this.$t(
          "resetpwd.ERR_SERVER_OLD_PWD_NOMATCH"
        )
      },
      passwordRules: {}
    };
  },
  methods: {
    createApiClient() {
      return new apiClient({
        $http: this.$http
      });
    },

    handleSubmit(e) {
      e.preventDefault();
      this.errorMsg = undefined;
      const returnUrl = `${config.baseUrl}/w2d`;
      const client = this.createApiClient();
      return client
        .sendPasswordResetRequest(this.formData.email, returnUrl)
        .then(response => {
          console.log("got ", response);
          window.alert(this.messages.MSG_EMAIL_SENT);
          if (this.$route.params.nextUrl != null) {
            this.$router.push(this.$route.params.nextUrl);
          } else {
            this.$router.push("/");
          }
        })
        .catch(error => {
          const response = error.response || error;
          const data = response.data || response;
          const remoteError = data.error;
          console.log("send reset password failed", response);
          if (
            response.status === 500 &&
            remoteError &&
            remoteError.errno === "ECONNREFUSED"
          ) {
            this.errorMsg = this.messages.ERR_REMOTE_UNREACHABLE;
            console.log(this.errorMsg);
          } else {
            if (data.message) {
              const errorMsg = this.serverMessages[data.message];
              if (errorMsg) {
                this.errorMsg = errorMsg;
              } else {
                this.errorMsg = `${this.messages.ERR_REMOTE_ERROR} ${data.message}`;
              }
            } else {
              this.errorMsg = JSON.stringify(error);
            }
          }
        });
    },

    goback() {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
div.login-outer {
  width: 100%;
}
div.login-inner {
  width: 400px;
  margin: 0 auto;
}
div.login-inner h4 {
  text-align: center;
}
input.loginField {
  width: 100%;
  margin-top: 4px;
  margin-bottom: 8px;
}
p.button-line {
  text-align: right;
}
ul.errors {
  list-style-position: inside;
}
</style>
